import { DragAndDrop } from 'components/dnd';
import LabelHelper from 'components/LabelHelper';
import {observer} from 'mobx-react';
import {AssignmentRule} from 'stores/documents';
import {t} from 'shared/core';
import _ from 'lodash';

const DocumentAssignmentRules = observer(({assignmentRules}) => {
  if (_.isEmpty(assignmentRules)) return null;
  
  return (
    <div style={{marginTop: '1.25rem'}}>
      <LabelHelper label={t('company_settings.documents.Completion Order')} />
      <DragAndDrop
        readOnlyDisplay='nameWithOrder'
        readOnly
        models={[new AssignmentRule({assigneeType: 'employee', order: -1})]}
      />
      <DragAndDrop
        models={assignmentRules}
        display='nameWithOrder'
      />
    </div>
  );

});

export default DocumentAssignmentRules;
